import { render, staticRenderFns } from "./LocationApptType.vue?vue&type=template&id=6fc2462a&scoped=true"
import script from "./LocationApptType.vue?vue&type=script&lang=js"
export * from "./LocationApptType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc2462a",
  null
  
)

export default component.exports